import { useLocation } from "react-router-dom";

export const getToken = () => {
  const res = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (!res) return "";
  else return res;
};

export const returnLoginStatus = () => {
  const res = getToken();
  if (!res) return false;
  else return true;
};

const logoutLogic = () => {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");

  window.location.replace("/login");
};

//401 에러가 났을 경우
export const ErrorLogic = (response) => {
  if (response.status == "401") {
    logoutLogic();
  }
};
